import { useEffect, useState } from 'react';
import { Modal, TextField, Button, Autocomplete } from '@mui/material';
import { Footer, ModalBox, ModalH2 } from './ModalItemStyle';
import ProdutoController from '../../../../controllers/ProdutoController';
import { OrdemServicoProduto } from '../../../../shared/types/OrdemServico';
import { MaquinaCadastrar } from '../../../../routes/RoutesNames';
import * as Icon from '@mui/icons-material';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setFieldValue: any;
  values: any;
}

const ModalItem = ({ open, onClose, setFieldValue, values }: ModalProps) => {
  const [produto, setProduto] = useState<OrdemServicoProduto | null>(null);
  const [produtoFeched, setProdutoFeched] = useState<any | null>(null);
  const [quantidade, setQuantidade] = useState('1');
  const [produtos, setProdutos] = useState<OrdemServicoProduto[]>([]);
  const [searchText, setSearchText] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [blockProduto, setBlockProduto] = useState(false);
  const [showButtonAdd, setShowButtonAdd] = useState(false);
  const [errorProduto, setErrorProduto] = useState(false);
  const [errorQuantidade, setErrorQuantidade] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  interface Produto {
    prod_id: number;
    prod_descricao: string;
  }

  useEffect(() => {
    const fetchData = async () => {
      if (values?.selectedItem?.item) {
        try {
          const response = await ProdutoController.ListarUnico(values.selectedItem.item.idItem);
          const produtoUnico = response.Data;
          setProduto(produtoUnico.prod_id ? { id: produtoUnico.prod_id, label: produtoUnico.prod_descricao, } : null);
          setProdutoFeched(produtoUnico);
          setQuantidade(values.selectedItem?.item?.quantidade);
          setIsUpdateMode(true);
          // setBlockProduto(true);
        } catch (error) {
          console.error('Erro ao buscar produto:', error);
        }
      } else {
        setIsUpdateMode(false);
      }
    };

    fetchData();
  }, [values?.selectedItem, open]);

  useEffect(() => {
    const fetchProdutos = async () => {
      const response = await ProdutoController.ListarMaquina(
        // O cast `as unknown as` que existia aqui era contorno para a MaquinaRequest,
        // que declarava os nomes das colunas do banco em vez dos da API. Corrigida a
        // interface, o objeto encaixa direto - e um nome errado volta a dar erro de
        // compilacao, que e o que se quer.
        { Descricao: searchText }
      );
      if (response.StatusCode === 200) {
        const lista = Array.isArray(response.Data) ? response.Data : [];
        setShowButtonAdd(lista.length === 0);
        setProdutos(
          response.Data.map((item: Produto) => ({
            id: item.prod_id,
            label: item.prod_descricao,
            ...item,
          }))
        );
      }
    };

    if (open && inputValue.length >= 1) {
      fetchProdutos();
    } else {
      setProdutos([]);
    }
  }, [open, inputValue, searchText]);

  const handleInputChange = (_event: any, newInputValue: any) => {
    setInputValue(newInputValue);
    setSearchText(newInputValue);
  };

  const handleSave = () => {
    let hasError = false;

    if (!produto) {
      setErrorProduto(true);
      hasError = true;
    } else {
      setErrorProduto(false);
    }

    if (!quantidade || parseInt(quantidade, 10) <= 0) {
      setErrorQuantidade(true);
      hasError = true;
    } else {
      setErrorQuantidade(false);
    }

    if (hasError) return;

    const newItem = {
      idItem: produto?.id,
      produto: produto?.label,
      quantidade,
      prod_marca: produto?.prod_marca ?? '',
      prod_modelo: produto?.prod_modelo ?? '',
      prod_numSerie: produto?.prod_numSerie ?? '',
    };

    let existingIndex = -1;
    if (isUpdateMode) {
      existingIndex = values.itensJson.findIndex(
        (item: any) => item.item.idItem === produtoFeched.prod_id
      );
    } else {
      existingIndex = values.itensJson.findIndex(
        (item: any) => item.item.idItem === newItem.idItem
      );
    }



    let updatedItensJson;
    if (existingIndex !== -1) {
      updatedItensJson = [...values.itensJson];
      updatedItensJson[existingIndex] = {
        item: { ...updatedItensJson[existingIndex].item, ...newItem },
      };
    } else {
      updatedItensJson = [...values.itensJson, { item: newItem }];
    }

    setFieldValue('itensJson', updatedItensJson);
    resetFormFields();
  };

  const handleClose = () => {
    resetFormFields();
  };

  const resetFormFields = () => {
    setProduto(null);
    setQuantidade('1');
    setInputValue('');
    setSearchText('');
    setBlockProduto(false);
    setFieldValue('selectedItem', null);
    onClose();
  };

  const handleAddProduct = () => {
    window.open(MaquinaCadastrar, '_black')
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalH2>Objeto de Manutenção</ModalH2>
        <Autocomplete
          options={produtos}
          getOptionLabel={(option) => option?.label || ''}
          value={produto}
          onChange={(_, newValue) => setProduto(newValue)}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.label}
            </li>
          )}
          disabled={blockProduto}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Produto'
              error={errorProduto}
              helperText={errorProduto ? 'Selecione um produto' : ''}
            />
          )}
        />

        <TextField
          label='Quantidade'
          type='number'
          fullWidth
          value={quantidade}
          onChange={(e) => setQuantidade(e.target.value)}
          sx={{ mt: 2 }}
          error={errorQuantidade}
          helperText={errorQuantidade ? 'Informe uma quantidade válida' : ''}
        />
        <Footer>
          <Button onClick={handleClose} color='error'>
            Cancelar
          </Button>
          {showButtonAdd && (
            <Button
              onClick={() => handleAddProduct()}
              color='info'
              startIcon={<Icon.Create />}
            >
              Criar
            </Button>
          )}
          <Button onClick={handleSave} variant='contained' color='primary'>
            Salvar
          </Button>
        </Footer>
      </ModalBox>
    </Modal>
  );
};

export default ModalItem;
